// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"41c5116f","498":"d36b857d","593":"a0f9c733","699":"f729dc98"}[chunkId] + ".chunk.js";
};